import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { DeviceEffects } from './mdm-devices.effects';
import { deviceReducer, mdmDevicesFeatureKey } from './mdm-devices.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(mdmDevicesFeatureKey, deviceReducer),
    EffectsModule.forFeature([DeviceEffects]),
  ],
  providers: [],
})
export class MdmDeviceStoreModule {}
